import {PreventionInvalidityCode} from "../preventative-interactions";
import {BaseImportTransformer, normalizeSpreadsheetCellValue, toPartNumberUpper} from "./shared";

/**
 * @param {*} item
 * @returns {boolean}
 */
function isExternalProductSeedRow(item) {
    if (!toPartNumberUpper(item?.partNumber)) return false;
    return !(normalizeSpreadsheetCellValue(item.internalId) && Number.isNaN(Number(normalizeSpreadsheetCellValue(item.internalId))));

}

/**
 * External products import (per industry) — phased validation (see {@link BaseImportTransformer} run contract).
 *
 * @param {Array<Object|null|undefined>} mappedData
 * @param {boolean} isFinalRun
 * @param {string|number} industryId
 */
export class ExternalProductsImportTransformer extends BaseImportTransformer {
    async run(mappedData, isFinalRun = false, industryId) {
        const rows = mappedData ?? [];
        const preventativeIssues = [];

        /** @type {{index: number, item: *, seedValid: boolean, codes: string[]}[]} */
        const rowState = rows.map((item, index) => ({
            index,
            item,
            seedValid: isExternalProductSeedRow(item),
            codes: [],
        }));

        for (const rs of rowState) {
            if (!rs.item) continue;
            if (!rs.seedValid) {
                rs.codes.push(PreventionInvalidityCode.MISSING_REQUIRED_FIELDS);
            }
        }

        for (const rs of rowState) {
            if (!rs.item) continue;
            if (!rs.codes.length) continue;
            preventativeIssues.push({
                rowIndex: rs.index,
                invalidityCodes: [...new Set(rs.codes)],
                originalRow: rs.item,
            });
        }

        const issueIndexSet = new Set(preventativeIssues.map((p) => p.rowIndex));

        const apiRequests = rows.map((item, index) => {
            if (!item) return null;
            if (issueIndexSet.has(index)) {
                return isFinalRun ? null : {internalId: null, partNumber: item.partNumber ?? null, industryId};
            }

            return {
                internalId: item.internalId ? Number(normalizeSpreadsheetCellValue(item.internalId)) : null,
                partNumber: toPartNumberUpper(item?.partNumber),
                industryId,
            };
        });

        return {apiRequests, preventativeIssues};
    }
}
